import { FloorExceptionalClosingHoursResponse, LocationCompressed } from '@jooxter/api';
import { isSameTimezoneAsTheUser, JxtEventColorsEnum } from '@jooxter/utils';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useTimezoneNameFormatter } from '../../hooks';
import { useFetchFloor } from '@jooxter/floors';
import { IJxtFloorExceptionalClosingHoursDetails } from '@jooxter/ui/src/components/JxtFloorExceptionalClosingHoursDetails/types';

export const useFloorExceptionalClosingHoursToIJxtFloorExceptionalClosingHoursDetailsAdapter = (
  selectedBuilding?: LocationCompressed,
  floorExceptionalClosingHours?: FloorExceptionalClosingHoursResponse | null
): { floorExceptionalClosingHoursDetails: IJxtFloorExceptionalClosingHoursDetails | undefined } => {
  const { floor } = useFetchFloor(floorExceptionalClosingHours?.floorId);
  const { format } = useTimezoneNameFormatter();
  const buildingTimezone = selectedBuilding?.timezone;
  const buildingName = selectedBuilding?.name;

  const floorExceptionalClosingHoursDetails: IJxtFloorExceptionalClosingHoursDetails | undefined = useMemo(() => {
    if (floorExceptionalClosingHours && floor && buildingTimezone && buildingName) {
      return {
        summary: {
          title: floorExceptionalClosingHours.title ?? '',
          color: JxtEventColorsEnum.Red,
        },
        date: {
          range: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            from: DateTime.fromISO(floorExceptionalClosingHours.timestampFrom!, { zone: buildingTimezone }),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            to: DateTime.fromISO(floorExceptionalClosingHours.timestampTo!, { zone: buildingTimezone }),
          },
          timezoneWarning: !isSameTimezoneAsTheUser(buildingTimezone) ? format(buildingTimezone) : undefined,
        },
        floor: {
          ...floor,
          locationName: buildingName,
          floor: floor.number,
        },
      };
    }
  }, [buildingTimezone, buildingName, floorExceptionalClosingHours, floor, format]);

  return { floorExceptionalClosingHoursDetails };
};
